import { type I18N } from '.';

export const da = {
  loginWith: 'Login med',
  approveWith: 'Godkend med',
  signWith: 'Underskriv med',
  confirmWith: 'Bekræft med',
  acceptWith: 'Accepter med',
  sameDevice: 'På denne enhed',
  anotherDevice: 'Med dit personnummer',
  anotherDeviceQR: 'På anden enhed',
  mitidBusiness: 'MitID Erhverv',
  finnishMobileID: 'Finsk Mobilcertifikat',
  finnishBankID: 'Finsk Bank ID',
  swedishBankID: 'Svensk BankID',
  norwegianBankID: 'Norsk BankID',
  biometrics: 'Biometri',
  openAndScan: 'Åbn BankID appen på din telefon og scan QR koden.',
  thisIsTheQR: 'Dette er en BankID QR-kode. Du kan klikke på den for at se den i fuld skærm.',
  completingLogin: 'Fuldfører dit login.',
} satisfies I18N;
